import Page from "@/components/Page";
import NotFind from "@/components/NotFind";
export default {
  Page,
  NotFind,
};
